<template>
	<Modal @close="$emit('close')">
		<span slot="title">Add/Edit Phone Number</span>
		<div slot="body">
			<PhoneNumber :readonly="readonly" v-for="idx in [0, 1, 2]" :key="idx" :phone="intPhones[idx]" @change-preferred="setPreferred(idx)" @phone-number-changed="changedPhone($event, idx)" @change-sms="changeSMS($event, idx)" />
		</div>
		<div class="field is-grouped" slot="footer">
			<div class="control">
				<a class="button is-small is-primary" @click="savePhones"><i class="fa fa-check"></i></a>
			</div>
			<div class="control">
				<a class="button is-small is-danger" @click="$emit('close')"><i class="fa fa-remove"></i></a>
			</div>
		</div>
	</Modal>
</template>

<script>
	import Modal from "../Modal.vue"
	import PhoneNumber from "./PhoneNumber.vue"
	
	export default {
		components: {
			Modal,
			PhoneNumber
		},
		data() {
			return {
				intPhones: []
			}
		},
		props: {
			phones: Array,
			id: String,
			readonly: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			setPreferred(idx) {
				for (let i = 0; i < this.intPhones.length; i++) {
					if (i === idx) {
						this.intPhones[i].preferred = true
					} else {
						this.intPhones[i].preferred = false
					}
				}
			},
			changedPhone(e, idx) {
				this.intPhones[idx].phone_number = parseInt(e.replaceAll("-", ""))
			},
			changeSMS(e, idx) {
				for (let i = 0; i < this.intPhones.length; i++) {
					if (i === idx && e) {
						this.intPhones[i].sms = true
					} else {
						this.intPhones[i].sms = false
					}
				}
			},
			async savePhones() {
				await this.$root.$data.setters.updatePhones(this.$root.$data.state, this.id, this.intPhones)
				this.$notify({
					group: 'global',
					type: 'success',
					title: 'Phones Saved',
					text: 'Your phone numbers have been saved.',
				})
				this.$emit('new-phones', this.intPhones.filter((p) => p.phone_number != ''))
				this.$emit('close')
			}
		},
		created() {
			this.intPhones = this.phones
			while (this.intPhones.length < 3) {
				this.intPhones.push({phone_number: '', preferred: false, time_zone_id: 11, country_code: this.intPhones[0].country_code, type: 3})
			}
		}
	}
</script>